import { FaChartBar, FaClipboardList, FaCloudDownloadAlt, FaFileAlt, FaFolderOpen } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { GrConfigure } from "react-icons/gr";
import { MdAccessTime, MdInsertPageBreak, MdLocationOff, MdOutlineDashboardCustomize, MdOutlineSettingsSuggest, MdOutlineShoppingCart } from "react-icons/md";
import { TiDeviceDesktop } from "react-icons/ti";

//Page Title: Dynamics CRM Integration
export const googleData = [
  {
    title: "IP Restriction",
    video: true,
    videoId: "B_8oFiesi68",
    videoType: "youtube",
    icon: <MdLocationOff className='text-white fs-5' />
  },
  {
    title: "Clipboard Restriction",
    video: true,
    videoId: "WWA-ggPvfR8",
    videoType: "youtube",
    icon: <FaClipboardList className='text-white fs-5' />
  },
  {
    title: "Download Restriction",
    video: true,
    videoId: "9TQ3gAZ1ido",
    videoType: "youtube",
    icon: <FaCloudDownloadAlt className='text-white fs-5' />
  },
  {
    title: "Time-based Restriction",
    video: true,
    videoId: "Q6CV1ko55U4",
    videoType: "youtube",
    icon: <MdAccessTime className='text-white fs-5' />
  },
  {
    title: "Location-based Restriction",
    video: true,
    videoId: "4MZvOo4Hqm8",
    videoType: "youtube",
    icon: <FaMapLocationDot className='text-white fs-5' />
  },
  {
    title: "Session file Restriction",
    video: true,
    videoId: "rNEsnBDOPt8",
    videoType: "youtube",
    icon: <FaFileAlt className='text-white fs-5' />
  },
  {
    title: "Session folder Restriction",
    video: true,
    videoId: "tpNWHP5CrJg",
    videoType: "youtube",
    icon: <FaFolderOpen className='text-white fs-5' />
  },
  {
    title: "Device Approval",
    video: true,
    videoId: "-2myOU90Gms",
    videoType: "youtube",
    icon: <TiDeviceDesktop className='text-white fs-5' />
  },
  {
    title: "Auditing Dashboard",
    video: true,
    videoId: "LtQqLfR4iDU",
    videoType: "youtube",
    icon: <FaChartBar className='text-white fs-5' />
  }
]